var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17188 8.05664L1.94336 2.82812C1.50586 3.44141 1.25 4.19141 1.25 5C1.25 7.07031 2.92969 8.75 5 8.75C5.81055 8.75 6.56055 8.49414 7.17188 8.05664ZM8.05664 7.17188C8.49414 6.55859 8.75 5.80859 8.75 5C8.75 2.92969 7.07031 1.25 5 1.25C4.18945 1.25 3.43945 1.50586 2.82812 1.94336L8.05664 7.17188ZM0 5C0 2.23828 2.23828 0 5 0C7.76172 0 10 2.23828 10 5C10 7.76172 7.76172 10 5 10C2.23828 10 0 7.76172 0 5Z",
    fill: "#F14242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAllowed);
export default __webpack_public_path__ + "static/media/not-allowed.57115af19cbc1c438161034b3a03c480.svg";
export { ForwardRef as ReactComponent };